import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=a21588c4&scoped=true&"
import script from "./Sync.vue?vue&type=script&lang=ts&"
export * from "./Sync.vue?vue&type=script&lang=ts&"
import style0 from "./Sync.vue?vue&type=style&index=0&id=a21588c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21588c4",
  null
  
)

component.options.__file = "Sync.vue"
export default component.exports